import { FC, useContext } from "react";
import { NewVersionContext } from "src/context/newversionContext";



const NewVersionModal: FC = (): JSX.Element => {
  const { isVersionModalVisible, changeVersionAlert } = useContext(NewVersionContext)

  return (
      <div
          className={`modal fade ${isVersionModalVisible ? 'show show-modal' : ''}`}
          id="exampleModal"
          tabIndex={-1}
          data-bs-backdrop="true"
          aria-hidden="true"
          onClick={(e) => { e.stopPropagation(); changeVersionAlert(!isVersionModalVisible)}}
      >
          <div className="modal-dialog modal-dialog-centered" style={{maxWidth:"600px"}}>
              <div className="modal-content">
                  <div className="modal-body text-center">
                      <i className="bi bi-exclamation-circle-fill text-success fs-1"></i>
                      <h3 className="">New Update Available</h3>
                      <p className="fs-6">
                          We’ve released a new version with enhancements to improve your experience.
                          Please click OK to apply the update.
                      </p>
                      <p className="m-0">This process may take a few minutes and may need a page refresh.</p>
                  </div>
                  <div className="modal-footer justify-content-center">
                      <button type="button" className="btn btn-primary btn-lg px-5" data-bs-dismiss="modal">OK</button>
                  </div>
              </div>
          </div>
      </div>
  )
}

export default NewVersionModal
